import React from 'react';
import { Marketing } from 'lib/templates/Feature.BOKF.model';
import ImageWrapper from 'helpers/ImageWrapper/ImageWrapper';
import RichTextA11yWrapper from 'helpers/RichTextA11yWrapper/RichTextA11yWrapper';
import { Text, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import LinkWrapper from 'helpers/LinkWrapper/LinkWrapper';

type FullWidthCardProps = Marketing.DataTemplates.Card;

const FullWidthCard = (props: FullWidthCardProps): JSX.Element => {
  const { Title, TitleLink, CardImage, Subtitle, CardContent } = props.fields || {};

  const hasValidLink = TitleLink && TitleLink.value && TitleLink.value.href;

  return (
    <section className="container spacing-md" data-id="full-width-card">
      <div className="bg-light-background-neutral-variant flex flex-col md:flex-row gap-y-6 md:gap-x-6 lg:gap-x-8 p-6 border border-solid border-light-stroke-primary">
        {CardImage?.value?.src && (
          <div className="md:w-1/4">
            <ImageWrapper field={CardImage} className="w-full h-full object-cover"></ImageWrapper>
          </div>
        )}
        <div
          className={`w-full text-center md:text-left flex flex-col gap-y-4 ${
            !CardImage?.value?.src ? '' : 'md:w-3/4'
          }`}
        >
          <div className="flex flex-col">
            {hasValidLink ? (
              <LinkWrapper field={TitleLink as LinkField} className="link p2-medium">
                <Text field={Title} />
              </LinkWrapper>
            ) : (
              <Text field={Title} tag="p" className="p2-medium" />
            )}
            <Text field={Subtitle} tag="p" className="c1" />
          </div>
          <RichTextA11yWrapper
            field={CardContent}
            tag="div"
            className="p2 text-light-fill-primary-variant rtaw"
          />
        </div>
      </div>
    </section>
  );
};

export default FullWidthCard;
